import { validateResponse } from "../../response.js";
import { getUploadTokenResponse } from "./specs.js";
const getUploadToken = async (apiUrl, { scope, referenceId, recaptchaToken }, init) => {
  const formData = new FormData();
  formData.append("scope", scope);
  formData.append("referenceId", referenceId);
  if (recaptchaToken) {
    formData.append("recaptchaToken", recaptchaToken);
  }
  return validateResponse(
    getUploadTokenResponse,
    await fetch(`${apiUrl}/upload/token`, {
      method: "POST",
      body: formData,
      ...init
    })
  );
};
export {
  getUploadToken
};
//# sourceMappingURL=get-upload-token.js.map
